import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=6dfa5c9a&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"
import style0 from "./Assets.vue?vue&type=style&index=0&id=6dfa5c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa5c9a",
  null
  
)

export default component.exports